/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'business-license': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M989.888 0H34.112C13.632 0 0 13.632 0 34.112v955.776C0 1010.368 13.632 1024 34.112 1024h955.776c20.48 0 34.112-13.632 34.112-34.112V34.112C1024 13.632 1010.368 0 989.888 0zm-34.176 955.712H68.288V68.288h887.424v887.424z"/><path pid="1" d="M227.584 640h568.832C817.792 640 832 627.2 832 608s-14.208-32-35.584-32H227.584C206.208 576 192 588.8 192 608s14.208 32 35.584 32zm0 132.288h568.832c21.376 0 35.584-13.696 35.584-34.176 0-20.48-14.208-34.112-35.584-34.112H227.584C206.208 704 192 717.632 192 738.112c0 20.48 14.208 34.176 35.584 34.176zm274.176-512c40.96 0 75.072 34.112 75.072 75.072s-34.112 75.072-75.072 75.072-75.072-34.112-75.072-75.072 30.72-75.072 75.072-75.072zm0-68.288A144.256 144.256 0 00358.4 335.36a144.256 144.256 0 00143.36 143.36 144.256 144.256 0 00143.36-143.36A144.256 144.256 0 00501.76 192z"/>'
  }
})
